const languages = {
  cz: "cs",
} as const;

export function localeToLang(locale: string): string {
  return languages[locale] || locale;
}
